import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { Navigation, Pagination, Autoplay } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import styled from '@emotion/styled'

import { useArticles } from 'utils/api/hooks'
import ContentWrapper from 'components/common/ContentWrapper'
import Link from 'components/common/A'
import TagButton, { OneLineGrid } from 'components/common/TagButton'
import { NavRightArrowSVG } from 'components/common/SVGElements'
import { HideInMobileBox } from 'components/common/Hidden'
import ArticleCard from './ArticleCard'

const modules = [Navigation, Pagination, Autoplay]

const ArticleSwiper = styled(Swiper)`
  ${({ theme }) => `
    .swiper-wrapper {
      ${theme.breakpoints.down('lg')} {
        margin-left: ${theme.spacing(4)};
      }
    }

    .swiper-slide {
      ${theme.breakpoints.down('lg')} {
        width: 252px;
      }
    }
  `}
`

const articleSwiperBreakpoints = {
  992: { spaceBetween: 24, slidesPerGroup: 4, slidesPerView: 4 },
}

const ArticleClassificationSwiper = ({ classification }) => {
  const { data: articles, isLoading } = useArticles({
    articleClassificationIds: [classification?._id],
    limit: 8,
  })

  return (
    <ContentWrapper
      mt={{ xs: 12, lg: 25 }}
      $xs={false}
      key={classification._id}
    >
      <ContentWrapper
        mb={8}
        display="flex"
        flexWrap="nowrap"
        alignItems="center"
        $lg={false}
        $xl={false}
        $xxl={false}
      >
        <Box flexGrow={1}>
          <Typography variant="h4">
            <Box
              fontWeight="fontWeightBold"
              display="flex"
              alignItems="center"
              color="text.minus2"
            >
              <Box whiteSpace="nowrap">{classification.name}</Box>
              {!!classification.keywords?.length && (
                <HideInMobileBox display="flex" alignItems="center">
                  <Box px={6}>
                    <Box height="14px" width="2px" bgcolor="background.line" />
                  </Box>
                  <OneLineGrid container spacing={2} alignItems="center">
                    {classification.keywords?.map((keyword) => (
                      <Grid item key={keyword._id}>
                        <TagButton href={`/article/tag/${keyword.urlId}`}>
                          {keyword.name}
                        </TagButton>
                      </Grid>
                    ))}
                  </OneLineGrid>
                </HideInMobileBox>
              )}
            </Box>
          </Typography>
        </Box>
        <Link href={`/article-classification/${classification?.urlId}`}>
          <Typography color="textSecondary">
            <Box display="flex" alignItems="center">
              <Box mr={3}>
                更多
                <HideInMobileBox component="span">
                  {classification.name}
                </HideInMobileBox>
              </Box>
              <NavRightArrowSVG textSecondary />
            </Box>
          </Typography>
        </Link>
      </ContentWrapper>
      <ArticleSwiper
        modules={modules}
        slidesPerView={'auto'}
        slidesPerGroup={1}
        spaceBetween={8}
        navigation
        breakpoints={articleSwiperBreakpoints}
      >
        {isLoading || !articles?.length ? (
          <SwiperSlide>
            <ArticleCard />
          </SwiperSlide>
        ) : (
          <>
            {articles?.map((article) => (
              <SwiperSlide key={article._id}>
                <ArticleCard article={article} />
              </SwiperSlide>
            ))}
          </>
        )}
      </ArticleSwiper>
    </ContentWrapper>
  )
}

export default ArticleClassificationSwiper
